import { $vi18n } from '@/utils/i18n.js';
export const checkoutMoney = (money, info) => {
  let reg = /^\d+(\.\d+)?$/;
  let errorMoneyTip = '';
  if (!money) {
    errorMoneyTip = $vi18n('$i18n# 提现数额不能为空 #i18n$');
  } else if (!reg.test(money)) {
    errorMoneyTip = $vi18n('$i18n# 请输入正确的数额 #i18n$');
  } else if (money > info.num) {
    errorMoneyTip = $vi18n('$i18n# 超过可提现金额 #i18n$');
  } else if (money < info.min) {
    errorMoneyTip = `${$vi18n('$i18n# 不满最小提现数额 #i18n$')}(${info.min})`;
  } else {
    errorMoneyTip = '';
  }
  return errorMoneyTip;
};
export const checkoutPhone = phone => {
  // $vi18n('$i1n# 手机号为后端返回的已加密格式 #i18n$')，$vi18n('$i# 不需再正则验证 #i18n$')
  let errorPhoneTip = '';
  if (!phone) {
    errorPhoneTip = $vi18n('$i18n# 手机号不能为空 #i18n$');
  } else {
    errorPhoneTip = '';
  }
  return errorPhoneTip;
};
export const checkoutCode = code => {
  let errorCodeTip = '';
  if (!code) {
    errorCodeTip = $vi18n('$i18n# 验证码不能为空 #i18n$');
  } else {
    errorCodeTip = '';
  }
  return errorCodeTip;
};
